import React from 'react';
import clsx from 'clsx';
import { CircleCheck, TriangleAlert, Info, CircleX, X } from 'lucide-react';

export interface AlertProps {
    variant?: 'success' | 'warning' | 'error' | 'info' | 'brand';
    title?: string;
    message: React.ReactNode;
    onClose?: () => void;
    action?: React.ReactNode;
    className?: string;
}

const styles = {
    success: 'bg-status-success-soft border-success-100 text-success-700',
    warning: 'bg-status-warning-soft border-warning-100 text-warning-600',
    error: 'bg-status-danger-soft border-danger-100 text-danger-700',
    info: 'bg-status-info-soft border-info-100 text-info-600',
    brand: 'bg-brandsoft border-primary-100 text-ink-brand',
};
const icons = { success: CircleCheck, warning: TriangleAlert, error: CircleX, info: Info, brand: Info };

/** Inline banner (DS Banner). */
export const Alert: React.FC<AlertProps> = ({ variant = 'info', title, message, onClose, action, className }) => {
    const Icon = icons[variant];
    return (
        <div role={variant === 'error' ? 'alert' : 'status'} className={clsx('flex items-start gap-3 rounded-md border p-4', styles[variant], className)}>
            <Icon className="mt-px w-5 h-5 shrink-0" />
            <div className="min-w-0 flex-1">
                {title && <p className="mb-0.5 text-base font-extrabold">{title}</p>}
                <p className="text-sm font-medium opacity-90">{message}</p>
                {action && <div className="mt-2">{action}</div>}
            </div>
            {onClose && (
                <button type="button" onClick={onClose} aria-label="Dismiss" className="shrink-0 rounded-sm p-0.5 opacity-70 hover:opacity-100">
                    <X className="w-4 h-4" />
                </button>
            )}
        </div>
    );
};
export default Alert;
